import React, { useCallback } from 'react';
import loadable from '@loadable/component';

import ProductFilter from '../../../product/components/product-filter';
import ProductMap from '../../../product/components/product-map';
import ProductShowPlaceholder from '../../../product/components/product-show-placeholder';
import FilteredProductList from './filtered-product-list';

import { Helpers } from '../../../core';

const GiftGuideTile = loadable(() => Helpers.retryFunc(() => import('../gift-guide-product-tile')));
const GiftGuideCard = loadable(() => Helpers.retryFunc(() => import('../gift-guide-product-card')));

export default ({
    onAdd,
    enableAppPDP,
    products,
    prdFilterCondition,
    leftMenu,
    sortGtmActions,
    ToggleFilter,
    disableSearch,
    tabProps,
    enableGiftGuideVisIdTile,
    pg,
}) => {
    const createCustomProductCard = useCallback(
        (product, key, enableAppPDP, className, productIndex, placeholder) => {
            //pass in placehodler that has price component so that prices are available earlier and can filter OOS/NO IR
            if (placeholder) {
                return <ProductShowPlaceholder product={product} className="gift-guide-product-card" />;
            }
            const props = {
                product,
                onAdd: () => {
                    onAdd(product);
                },
                key,
            };
            return enableGiftGuideVisIdTile ? <GiftGuideTile {...props} /> : <GiftGuideCard {...props} />;
        },
        [onAdd],
    );

    if (!disableSearch) {
        return (
            <FilteredProductList
                leftMenu={leftMenu}
                createCustomProductCard={createCustomProductCard}
                enableAppPDP={enableAppPDP}
                ToggleFilter={ToggleFilter}
                sortGtmActions={sortGtmActions}
                prdFilterCondition={prdFilterCondition}
                disableSearch={disableSearch}
                tabProps={tabProps}
                pg={pg}
            />
        );
    }

    return (
        <ProductFilter products={products} condition={prdFilterCondition}>
            {filteredProducts => (
                <ProductMap
                    products={filteredProducts}
                    productItem={createCustomProductCard}
                    enableAppPDP={enableAppPDP}
                    lazyLoadPlaceHolderHeight={1040}
                    productItemClassName={'gift-guide-product-card'}
                    customPlaceHolder={true}
                    disableMultiContainers={true}
                    containerClassName="column-container"
                />
            )}
        </ProductFilter>
    );
};
